export default {
  displaySnackBar(context, params) {
    context.commit("setSnackBar", params);
  },
  closeSnackBar(context) {
    context.commit("clearSnackBar");
  },
  loading(context, loading) {
    context.commit("loading", loading);
  }
};
